export const STORAGE_KEYS = Object.freeze({
	AUTH: 'userData',
	LANG: 'language',
	VALET: 'valet',
})

export const setValue = (data: unknown): string => {
	if (typeof data === 'string') {
		return data
	}

	return JSON.stringify(data)
}

export const setLocalStorage = (key: string, data: unknown): void => {
	const value = setValue(data)

	globalThis.localStorage.setItem(key, value)
}

export const removeLocalStorage = (key: string): void => {
	globalThis.localStorage.removeItem(key)
}

export const getLocalStorage = <T>(key: string): T | null => {
	const value = globalThis.localStorage.getItem(key)

	if (value === null) {
		return null
	}

	try {
		return JSON.parse(value)
	} catch {
		return value as unknown as T
	}
}
